import { render } from "./Downloads.vue?vue&type=template&id=82187062&scoped=true&ts=true"
import script from "./Downloads.vue?vue&type=script&lang=ts"
export * from "./Downloads.vue?vue&type=script&lang=ts"

import "./Downloads.vue?vue&type=style&index=0&id=82187062&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82187062"]])

export default __exports__